import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ProductCategoryReportEntity } from './product-category-report.model';

@Injectable({
    providedIn: 'root'
})
export class ProductCategoryReportService {
	private httpClient = inject(HttpClient);

	list(subscriberKey: number) {
			return this.httpClient.get<ProductCategoryReportEntity[]>(`api/subscriber/${subscriberKey}/product-category-reports`);
		}
}
